import { render } from "./Publish_submit.vue?vue&type=template&id=4da5fb12&scoped=true"
import script from "./Publish_submit.vue?vue&type=script&lang=js"
export * from "./Publish_submit.vue?vue&type=script&lang=js"

import "./Publish_submit.vue?vue&type=style&index=0&id=4da5fb12&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\oversea-website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4da5fb12"]])

export default __exports__